<template>
  <div class="col-sm-12 nopads">
    <div class="ps-2 pe-2">
      <div class="col-sm-12 search-form-title">
        <font-awesome-icon icon="search" />
        {{ $t('common.search') }}
      </div>
          <div class="row">
            <div class="col-sm-4">
              <span class="search-title">
                {{ $t('delivery_note.date') }} - {{ $t('trip_list.road_sec_from') }}
              </span>
              <date-time-picker
                v-model:date="fromTime"
                class="routa-input"
                format="dd.MM.yyyy HH:mm"
                :enableTimePicker="true"
                :placeholder="$t('observations_videos.search_input_format')"
              />
            </div>
            <div class="col-sm-4">
              <span class="search-title">
                {{ $t('delivery_note.date') }} - {{ $t('trip_list.road_sec_to') }}</span>
              <date-time-picker
                v-model:date="toTime"
                class="routa-input"
                format="dd.MM.yyyy HH:mm"
                :enableTimePicker="true"
                :placeholder="$t('observations_videos.search_input_format')"
              />
            </div>
              <div class="col-sm-4">
              <span class="search-title">{{ $t('material_reports.material') }}</span>
                  <multiselect
                      v-model="material"
                      class="multiselect_routa"
                      :placeholder="$t('delivery_note.form.select_material')"
                      :deselect-label="$t('common.remove_selection')"
                      :select-label="$t('common.select')"
                      :close-on-select="true"
                      label="name"
                      track-by="name"
                      :searchable="true"
                      :internal-search="true"
                      :multiple="false"
                      :selected-label="$t('common.selected')"
                      :options="materialOptions"
                  >
                  </multiselect>
              </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <span class="search-title">{{ $t('orders.contract') }}</span>
                    <open-contract-filter
                        :to="toTime"
                        :from="fromTime"
                        :show-company="false"
                        :show-title="false"
                        :show-only-my-contracts-option="true"
                        @loading="loading++"
                        @loading-completed="loading--"
                        @contract-selected="setContract"
                        @contracts-fetched="handleContractsFetched"
                    />
            </div>
            <div class="col-sm-6">
              <span class="search-title">{{ $t('trip_list.vehicle') }}</span>
              <multiselect
                    v-model="vehicle"
                    class="multiselect_routa"
                    :placeholder="$t('trip_list.select_vehicle')"
                    :deselect-label="$t('common.remove_selection')"
                    :select-label="$t('common.select')"
                    :close-on-select="true"
                    label="name"
                    track-by="name"
                    :searchable="true"
                    :internal-search="true"
                    :selected-label="$t('common.selected')"
                    :options="vehicles"
              >
                <template
                  #singleLabel="props"
                >
                  <span class="option__desc">
                    <span class="option__title">{{ props.option.name }}</span>
                  </span>
                </template>
                <template
                  #option="props"
                >
                  <div class="option__desc">
                    <span class="option__title multiselect_detail_block">{{ props.option.name }}</span>
                  </div>
                </template>
                <template #noResult>
                  <span>{{ $t('common.not_found') }}</span>
                </template>
                <template #noOptions>
                  <span>{{ $t('common.no_results') }}</span>
                </template>
              </multiselect>
            </div>
          </div>

        <!-- Road address params -->
        <!-- Beta feature info -->
        <div class="search-form p-3 my-3" style="border: 1px solid #BCBCBC">
            <strong>HUOM!</strong> Tieosoitehaku toimii toistaiseksi ainoastaan sirotinjärjestelmien tuottamalla datalla (ei käyttäjien lisäämillä reiteillä)!
        </div>

        <div class="row">
            <div class="col-sm-4">
                <span class="search-title">{{ $t('trip_list.search_with_road_num') }}</span>
                <input
                    id="roadInput"
                    v-model="roadFrom"
                    :class="roadFrom || roadAddressParamsOk ? 'is-valid' : 'is-invalid'"
                    type="number"
                    class="form-control form-control-sm no-margin"
                    :placeholder="$t('trip_list.search_with_road_num')"
                />
            </div>
            <div class="col-sm-4">
                <span class="search-title">{{ $t('map.road_section_start') }}</span>
                <input
                    id="roadInput"
                    v-model="secFrom"
                    :class="secFrom || roadAddressParamsOk ? 'is-valid' : 'is-invalid'"
                    type="number"
                    class="form-control form-control-sm no-margin"
                    :placeholder="$t('map.road_section')"
                />
            </div>
            <div class="col-sm-4">
                <span class="search-title">{{ $t('map.distance_start')  }}</span>
                <input
                    id="distance-from"
                    v-model="distanceFrom"
                    :class="distanceFrom || roadAddressParamsOk ? 'is-valid' : 'is-invalid'"
                    type="number"
                    min="0"
                    step="1"
                    class="form-control form-control-sm"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4"/>
            <div class="col-sm-4">
                <span class="search-title">{{ $t('map.road_section_end') }}</span>
                <input
                    id="roadInput"
                    v-model="secTo"
                    :class="secTo || roadAddressParamsOk ? 'is-valid' : 'is-invalid'"
                    type="number"
                    class="form-control form-control-sm no-margin"
                    :placeholder="$t('map.road_section')"
                />
            </div>
            <div class="col-sm-4">
                <span class="search-title">{{ $t('map.distance_end')  }}</span>
                <input
                    id="distance-from"
                    v-model="distanceTo"
                    :class="distanceTo || roadAddressParamsOk ? 'is-valid' : 'is-invalid'"
                    type="number"
                    min="0"
                    step="1"
                    class="form-control form-control-sm"
                />
            </div>
        </div>


          <div class="col-sm-12 button-container">
              <button v-if="hasElyContracts" class="btn btn-sm btn-secondary form-button align-self-end" @click.stop="createRouteWithMaterials">
                  {{ $t('contracts.external.route_reports_with_no_route') }}
              </button>
            <button
              type="reset"
              class="btn btn-sm btn-danger form-button"
              @click.stop="onReset"
            >
              {{ $t('ins_report.clear') }}
            </button>
            <button
                type="submit"
                class="btn btn-sm btn-primary form-button"
                :disabled="!roadAddressParamsOk"
                @click.stop="onSubmit"
            >
                {{ $t('ins_report.search') }}
            </button>
          </div>
        <base-modal v-if="showRouteMaterialCreator" hide-header hide-footer no-padding size="xl">
            <route-material-creator @close="closeModal" :user="user"/>
        </base-modal>
      </div>
  </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import {timeUtils} from '../../mixins/TimeUtils'
import OpenContractFilter from "@/components/contract/OpenContractFilter";
import DateTimePicker from "@/components/common/DateTimePicker";
import RouteMaterialCreator from "@/components/harja/RouteMaterialCreator.vue";
import BaseModal from "@/components/BaseModal.vue";
import {spreaderDataMixin} from "../../mixins/SpreaderDataMixin.js";
import {inject} from "vue";

export default {
    name: 'SpreaderDataSearch',
    components: {BaseModal, RouteMaterialCreator, OpenContractFilter, DateTimePicker},
    mixins: [restApi, timeUtils, spreaderDataMixin],
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            loading: false,
            contracts: [],
            vehicles: [],
            fromTime: null,
            toTime: null,
            contract: null,
            vehicle: null,
            showRouteMaterialCreator: false,
            hasElyContracts: false,
            roadFrom: null,
            secFrom: null,
            distanceFrom: null,
            secTo: null,
            distanceTo: null,
            material: null,
            materialOptions: []
        }
    },
    computed: {
        roadAddressParamsOk() {
            // None given, all ok
            if (!this.roadFrom && !this.secFrom && !this.distanceFrom && !this.secTo && !this.distanceTo) {
                return true
            }
            // All given
            return this.roadFrom && this.secFrom && this.distanceFrom && this.secTo && this.distanceTo
        }
    },
    mounted: function () {
        this.fromTime = this.getMonthStart()
        this.toTime = this.timestampToISOString(new Date().getTime())
        this.fetchVehicles()
        this.initMaterials()
    },
    methods: {
        initMaterials()  {
            this.materialOptions = []
            this.materialOptions.push(...this.getDryMaterials().map(function (item) {
                return {
                    value: item.value,
                    name: item.text
                }
            }))
            this.materialOptions.push(...this.getLiquidMaterials().map(function (item) {
                return {
                    value: item.value,
                    name: item.text
                }
            }))
        },

        closeModal() {
            this.showRouteMaterialCreator = false
        },
        handleContractsFetched(contracts) {
            this.hasElyContracts = contracts.some(contract => contract.ely_contract)
        },
        fetchVehicles: function () {
            this.loading++
            this.vehicles = []
            this.restFetchParams(this.vehicleUrl, {only_spreader_vehicles: true}, this.handleVehicles)
        },
        createRouteWithMaterials() {
            this.showRouteMaterialCreator = true
        },
        handleVehicles: function (response) {
            this.loading--
            if (response && response.data && response.data.length > 0) {
                this.vehicles = response.data.map(function (item) {
                    return {
                        value: item.id,
                        name: item.make + ' ' + item.vehicle_model + ' - ' + item.license_plate
                    }
                })
            }
        },
        setElyContract(elyContract) {
            this.elyContract = elyContract
        },
        setContract(contract) {
            this.contract = contract
        },
        onSubmit: function () {
            var params = {}
            if (this.vehicle) {
                params.vehicle = this.vehicle.value
            }
            if (this.contract) {
                params.contract = this.contract.id
            }
            params.from = this.fromTime
            params.to = this.toTime
            if (this.material) {
                params.material = this.material.value
            }
            if (this.roadFrom) {
                params.roadNum = this.roadFrom
                params.secFrom = this.secFrom
                params.distFrom = this.distanceFrom
                params.secTo = this.secTo
                params.distTo = this.distanceTo
            }
            this.$emit('search', params)
        },

        onReset: function () {
            this.vehicles = []
            this.toDate = null
            this.roadFrom = null
            this.secFrom = null
            this.distanceFrom = null
            this.secTo = null
            this.distanceTo = null
            this.material = null
        }
    }
}
</script>

